// @flow
import _ from 'lodash'
import React, { Component } from 'react'
import ReactSelect from 'react-select'
import { OrtSelectStyles, OrtSelectComponents } from './Select'
import type { InnerOption } from './Select'
import type { OptionType, GroupedOptionType } from '../types'
import { innerOptions, flatInnerOptions } from './Select/optionTransformations'

type Props = {|
  value: Array<any>,
  options: Array<OptionType>,
  groupedOptions?: Array<GroupedOptionType>,
  placeholder?: string,
  disabled?: boolean,
  htmlProperties?: Object,
  onChange: (Array<any>) => void,
  isClearable?: boolean,
  noResultsText?: ?string,
  className?: string,
  selectAll?: boolean,
  onInputChange?: Function
|}

const t = {
  select_all: 'Выбрать все'
}

export default class MultiSelect extends Component<Props> {
  render() {
    const areAllOptionsSelected = _.isEqual(this.innerValue().length, this.allOptions().length)
    return (
      <ReactSelect
        isMulti
        closeMenuOnSelect={false}
        value={
          this.props.selectAll && areAllOptionsSelected ? this.allOptions() : this.innerValue()
        }
        options={this.innerOptionsWithGroups(areAllOptionsSelected)}
        isClearable={this.props.isClearable || false}
        isDisabled={this.props.disabled}
        placeholder={this.props.placeholder}
        noOptionsMessage={() => this.props.noResultsText}
        styles={OrtSelectStyles}
        components={OrtSelectComponents}
        onChange={(options) => {
          if (
            this.props.selectAll &&
            !areAllOptionsSelected &&
            _.last(options) &&
            _.last(options).value === this.selectAllOption().id
          ) {
            return this.changed(this.allOptions())
          }
          return this.changed(options)
        }}
        className={this.props.className}
        onInputChange={(q) => this.props.onInputChange && this.props.onInputChange(q)}
        {...this.props.htmlProperties}
      />
    )
  }

  innerOptionsWithGroups(areAllOptionsSelected: boolean): Array<InnerOption> {
    const options =
      this.props.selectAll && !areAllOptionsSelected
        ? [this.selectAllOption(), ...this.props.options]
        : this.props.options
    return innerOptions(options, this.props.groupedOptions)
  }

  changed(options: Array<InnerOption>) {
    this.props.onChange(_.map(options, (o) => o.value))
  }

  innerValue(): Array<InnerOption> {
    return _.filter(this.allOptions(), (option) => _.includes(this.props.value, option.value))
  }

  allOptions(): Array<InnerOption> {
    return flatInnerOptions(this.props.options, this.props.groupedOptions)
  }

  selectAllOption(): OptionType {
    return { id: 'select_all', name: t.select_all }
  }
}
